import {css, cx} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

interface IProps {
    active: boolean;
    hasDeckBehind: boolean;
    reduceMotion: boolean;
}

export function TinderMultiLeadDeckPlaceholder({active, hasDeckBehind, reduceMotion}: IProps) {
    return (
        <AnimatePresence>
            {active ? (
                <motion.div
                    className={cx(placeholderBaseStyle, hasDeckBehind ? placeholderTopBehindStyle : placeholderTopFrontStyle)}
                    initial={{opacity: 1}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: reduceMotion ? 0 : 0.2, ease: [0.4, 0, 0.2, 1]}}
                    aria-hidden
                />
            ) : null}
        </AnimatePresence>
    );
}

const placeholderBaseStyle = css({
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
    borderRadius: 2,
    backgroundColor: "var(--colors-gray-200)",
    pointerEvents: "none"
});

const placeholderTopFrontStyle = css({top: 0});

const placeholderTopBehindStyle = css({top: "56px"});
import {css, cx} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

interface IProps {
    active: boolean;
    hasDeckBehind: boolean;
    reduceMotion: boolean;
}

export function TinderMultiLeadDeckPlaceholder({active, hasDeckBehind, reduceMotion}: IProps) {
    return (
        <AnimatePresence>
            {active ? (
                <motion.div
                    className={cx(placeholderBaseStyle, hasDeckBehind ? placeholderTopBehindStyle : placeholderTopFrontStyle)}
                    initial={{opacity: 1}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: reduceMotion ? 0 : 0.2, ease: [0.4, 0, 0.2, 1]}}
                    aria-hidden
                />
            ) : null}
        </AnimatePresence>
    );
}

const placeholderBaseStyle = css({
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
    borderRadius: 2,
    backgroundColor: "var(--colors-gray-200)",
    pointerEvents: "none"
});

const placeholderTopFrontStyle = css({top: 0});

const placeholderTopBehindStyle = css({top: "56px"});
